module.exports = __webpack_public_path__ + "static/media/z&v1.049f9af2.jpg";